export const COLORS = {
  WHITE: '#ffffff',
  PAPER: '#fafaf9',
  PAPER_DARK: '#eef1f4',
  TEXT: '#1a1a1a',
  TEXT_SECONDARY: '#4f4f4f',
  INK: '#0e1c2b',
  PRIMARY: '#1890ff',
  PRIMARY_LIGHT: '#69c0ff',
  PRIMARY_DARK: '#0050b3',
  PRIMARY_SURFACE: '#e6f7ff',
  PRIMARY_BORDER: '#bae7ff',
  GRAY: {
    surface: '#f8fafc',
    surfaceTint: '#f4f8fc',
    borderLight: '#f1f5f9',
    border: '#e2e8f0',
    divider: '#cbd5e1',
    mutedLight: '#94a3b8',
    muted: '#64748b',
    slate: '#475569',
    body: '#334155'
  },
  GOLD: {
    gold1: '#fffbe6',
    gold2: '#fff1b8',
    gold3: '#ffe58f',
    gold4: '#ffd666',
    gold5: '#ffc53d',
    gold6: '#faad14',
    gold7: '#d48806',
    gold8: '#ad6800',
    gold9: '#874d00',
    gold10: '#613400'
  },
  GREEN: {
    green1: '#f6ffed',
    green2: '#d9f7be',
    green3: '#b7eb8f',
    green4: '#95de64',
    green5: '#73d13d',
    green6: '#52c41a',
    green7: '#389e0d',
    green8: '#237804',
    green9: '#135200',
    green10: '#092b00'
  }
};
